/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

export const createProductVendor = createAsyncThunk(
  'productVendors/create',
  async ({ title }, { extra: { sdk, utils, Logger } }) => {
    const trimmedTitle = title.trim();
    try {
      const { data } = await sdk.productVendors.create({ title: trimmedTitle });
      return { productVendor: data };
    } catch (error) {
      const subcode = utils.getDataFromResponceError(error, 'subcode');
      if (subcode === 'ProductVendorAlreadyExistsApiError') {
        /** duplicate title is not a hard failure: let the caller proceed with saving it */
        return { alreadyExists: true, title: trimmedTitle };
      }
      Logger.error(new Error('Can not create product vendor'), { error }, [
        'CreateProductVendorFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(createProductVendor.pending, (state) => {
      state.error = null;
    })
    .addCase(createProductVendor.fulfilled, (state, { payload }) => {
      state.hasRegistryItems = true;
      if (payload.alreadyExists) return;
      state.items.push(payload.productVendor);
    })
    .addCase(createProductVendor.rejected, (state, { error }) => {
      state.error = error;
    });
};
